<div class="information-abattement">
	<p *ngIf="disableAbattementManuel || !acte.isAbattementForced">{{ acte.taxAllowanceExplication }}</p>
	<p *ngIf="!disableAbattementManuel && acte.isAbattementForced">Taux fixé manuellement</p>
	<div *ngIf="!disableAbattementManuel" class="tauxList">
		<div *ngFor="let tauxItem of tauxOptions">
			<lua-option-data-picker [label]="tauxItem.label" [isSelected]="tauxItem.value == taux"
				(click)="onTauxChange(tauxItem.value)"></lua-option-data-picker>
		</div>
	</div>
	<div class="ligne-honoraire">
		<small>Honoraire de l'acte</small>
		<small>{{ acte.initialPrice * acte.initialPriceCoefficient | priceFormat:2 }} €</small>
	</div>
	<div class="ligne-honoraire">
		<strong>Honoraire appliqué</strong>
		<strong>{{ acte.price !== 0 ? (acte.price | priceFormat:2) + ' €' : 'GRATUIT' }}</strong>
	</div>
	<div class="button-footer">
		<lua-bouton-texte libelle="Fermer" (click)="close()"></lua-bouton-texte>
	</div>
</div>